export const DOCUMENT_TYPE_LOGIN_PAGE = 'loginpage'
export const DOCUMENT_TYPE_MANAGE_BUSINESS = 'manage-business'
export const DOCUMENT_TYPE_MAIN_MENU = 'menu'
export const DOCUMENT_TYPE_GENERAL_COMPLIANCE = 'general-compliance'
export const DOCUMENT_TYPE_PROJECTS_LIST = 'projects-list'
export const DOCUMENT_TYPE_STATIC_PAGE = 'static-page'
export const DOCUMENT_TYPE_INDICATOR = 'indicator'
export const DOCUMENT_TYPE_INDICATOR_GENERAL_ENTERPRISE = 'conformity-indicator-enterprise-list'
export const DOCUMENT_TYPE_INDICATOR_GENERAL_PROVIDER = 'conformity-indicator-provider-list'
export const DOCUMENT_TYPE_INDICATOR_PROJECT_ENTERPRISE = 'project-indicator-enterprise-list'
export const DOCUMENT_TYPE_INDICATOR_PROJECT_PROVIDER = 'project-indicator-provider-list'
export const DOCUMENT_TYPE_INDICATOR_DETAIL = 'indicator-detail'
export const DOCUMENT_TYPE_MANUAL = 'manual'
